import { Action, Reducer } from 'redux';

// actions
import * as Actions from '../actions';
import { CashFlowPaymentImputationsState, PaymentImputationsUnloadState } from '../states/CashFlow.PaymentImputations.State';

type KnownAction =
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationsGetAllRequestAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationsGetAllSuccessAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationsGetAllFailureAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationRollbackRequestAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationRollbackSuccessAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationRollbackFailureAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationCreateRequestAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationCreateSuccessAction
    | Actions.CashFlowPaymentImputations.CashFlowPaymentImputationCreateFailureAction;

export const CashFlowPaymentImputationsReducer: Reducer<CashFlowPaymentImputationsState> = (
    state: CashFlowPaymentImputationsState | undefined,
    incomingAction: Action
): CashFlowPaymentImputationsState => {
    if (state === undefined) {
        return PaymentImputationsUnloadState;
    }

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case 'CASHFLOW_PAYMENT_IMPUTATIONS_GETALL_REQUEST':
            return {
                ...state,
                isLoadingImputations: true,
                successLoadingImputations: undefined,
                failOnLoadingImputations: false,
                currentPaymentId: action.paymentId,
                error: undefined
            };
        case 'CASHFLOW_PAYMENT_IMPUTATIONS_GETALL_SUCCESS':
            return {
                ...state,
                isLoadingImputations: false,
                successLoadingImputations: true,
                failOnLoadingImputations: false,
                currentPaymentId: action.paymentId,
                imputations: action.payload,
                error: undefined
            };
        case 'CASHFLOW_PAYMENT_IMPUTATIONS_GETALL_FAILURE':
            return {
                ...state,
                isLoadingImputations: false,
                successLoadingImputations: false,
                failOnLoadingImputations: true,
                error: action.error
            };
        case 'CASHFLOW_PAYMENT_IMPUTATION_ROLLBACK_REQUEST':
            return {
                ...state,
                isRollingBack: true,
                successRollingBack: undefined,
                failOnRollingBack: false,
                error: undefined
            };
        case 'CASHFLOW_PAYMENT_IMPUTATION_ROLLBACK_SUCCESS':
            return {
                ...state,
                isRollingBack: false,
                successRollingBack: true,
                failOnRollingBack: false,
                imputations: state.imputations.filter(i => i.imputationId !== action.imputationId),
                error: undefined
            };
        case 'CASHFLOW_PAYMENT_IMPUTATION_ROLLBACK_FAILURE':
            return {
                ...state,
                isRollingBack: false,
                successRollingBack: false,
                failOnRollingBack: true,
                error: action.error
            };
        case 'CASHFLOW_PAYMENT_IMPUTATION_CREATE_REQUEST':
            return {
                ...state,
                isCreatingImputation: true,
                successCreatingImputation: undefined,
                failOnCreatingImputation: false,
                error: undefined
            };
        case 'CASHFLOW_PAYMENT_IMPUTATION_CREATE_SUCCESS':
            return {
                ...state,
                isCreatingImputation: false,
                successCreatingImputation: true,
                failOnCreatingImputation: false,
                imputations: [...state.imputations, action.payload],
                error: undefined
            };
        case 'CASHFLOW_PAYMENT_IMPUTATION_CREATE_FAILURE':
            return {
                ...state,
                isCreatingImputation: false,
                successCreatingImputation: false,
                failOnCreatingImputation: true,
                error: action.error
            };
        default:
            return state;
    }
};
